<div class="dialog">
  @if (gallery.teaser?.uuid || accessLevel === 'edit') {
    @if (gallery.teaser?.uuid) {
      <div class="gallery-asset" #el>
        <img
          [src]="gallery | galleryTeaserUrl: el.clientWidth"
          [style.object-position]="gallery.teaser.uuid === gallery.cover.uuid ? gallery.cover.position : undefined"
          alt=""
        />
        @if (accessLevel === 'edit') {
          <div class="remove-teaser dark">
            <button
              appButton
              name="remove-teaser"
              location="gallery-info-dialog"
              color="hard-simple"
              height="1"
              shape="round"
              [iconButton]="true"
              (click)="removeTeaser()"
            >
              <app-svg src="/assets/icons/trash.svg"></app-svg>
            </button>
          </div>
        }
      </div>
    }
    @if (!gallery.teaser?.uuid) {
      <label class="gallery-asset empty" for="teaser-upload">
        <input
          type="file"
          id="teaser-upload"
          accept="image/*"
          class="hidden-input"
          (change)="uploadTeaserEvent($event.target)"
        />
        <app-svg src="/assets/icons/image-upload.svg"></app-svg>
      </label>
    }
  }
  @if (accessLevel === 'edit') {
    <form [formGroup]="form">
      <app-input-field [control]="form.controls.name" [big]="true" [noLabel]="true">
        <input
          type="text"
          formControlName="name"
          [placeholder]="gallery.title || 'Untitled'"
          data-test-id="gallery-name"
        />
      </app-input-field>
    </form>
  }
  @if (accessLevel !== 'edit') {
    <h2>
      {{ gallery.name || gallery.title || 'Untitled' }}
    </h2>
  }
  <div class="info-table">
    <div class="info-row">
      <div class="info-key">Status</div>
      @if (gallery.enabled_gallery_statuses.length <= 1) {
        <div class="info-value not-enabled">Not enabled</div>
      } @else {
        <div>
          <app-context-menu [options]="{ width: '240px', noSpacing: true }" #menu>
            <button
              appButton
              name="change-gallery-status"
              location="gallery-info-dialog"
              class="gallery-status-button"
              data-test-id="change-gallery-status"
              weight="bold"
              height="1"
              spacing="1"
              [color]="gallery.status | galleryStatusButtonColor"
              contextButton
            >
              <app-svg src="/assets/icons/{{ gallery.status | galleryStatusIcon }}.svg"></app-svg>
              <span>{{ gallery.status | galleryStatusName }}</span>
              <app-svg src="/assets/icons/12/chevron-down.svg" size="-2"></app-svg>
            </button>
            <app-gallery-status-context
              contextContent
              [gallery]="gallery"
              (onSelectStatus)="updateGalleryStatus($event); menu.close()"
            ></app-gallery-status-context>
          </app-context-menu>
        </div>
      }
    </div>
    @if (owner) {
      <div class="info-row">
        <div class="info-key">Owner</div>
        <div class="info-value info-value-flex">
          <div class="image-border"></div>
          <app-avatar [user]="owner"></app-avatar>
          <span>{{ owner.first_name }} {{ owner.last_name }}</span>
        </div>
      </div>
    }
    <div class="info-row">
      <div class="info-key">Created</div>
      <div class="info-value" [appTooltip]="gallery.created_at * 1000 | date: 'short'" toolTipOrigin="top-left">
        {{ gallery.created_at * 1000 | relativeTime }}
      </div>
    </div>
    <div class="info-row">
      <div class="info-key">Modified</div>
      <div class="info-value" [appTooltip]="gallery.last_changed_at * 1000 | date: 'short'" toolTipOrigin="top-left">
        {{ gallery.last_changed_at * 1000 | relativeTime }}
      </div>
    </div>
    @if (tenant) {
      <div class="info-row">
        <div class="info-key">Workspace</div>
        <div class="info-value info-value-flex">
          @if (tenant.favicon_url) {
            <img [src]="tenant.favicon_url" class="tenant-image" alt="" />
          }
          @if (!tenant.favicon_url) {
            <div class="tenant-image no-image">
              <span>{{ (tenant.name || 'U' | uppercase)[0] }}</span>
            </div>
          }
          <div class="image-border"></div>
          <span>{{ tenant.name }}</span>
        </div>
      </div>
    }
  </div>
  <div class="button-row">
    @if (accessLevel === 'edit' && !isGalleryGuest) {
      <button
        appButton
        name="delete"
        location="gallery-info-dialog"
        [iconButton]="true"
        shape="round"
        height="3"
        (click)="deleteGallery()"
      >
        <app-svg src="/assets/icons/trash.svg" color="warn"></app-svg>
      </button>
    }
    <div class="separator"></div>
    @if (accessLevel === 'edit' && !isGalleryGuest) {
      <button
        appButton
        name="move-to"
        location="gallery-info-dialog"
        height="3"
        spacing="3"
        weight="bold"
        shape="round"
        (click)="openMoveToDialog()"
      >
        Move/Copy
      </button>
    }
    @if (accessLevel === 'edit') {
      <button
        appButton
        name="share"
        location="gallery-info-dialog"
        height="3"
        spacing="3"
        shape="round"
        color="primary"
        [hasIcon]="true"
        (click)="share()"
      >
        <app-svg src="/assets/icons/forward.svg"></app-svg>
        <span>Share</span>
      </button>
    }
  </div>
</div>
